/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Company } from '../models/company';
import { createOneBaseMgmtSupplierControllerCompany } from '../fn/supplier/create-one-base-mgmt-supplier-controller-company';
import { CreateOneBaseMgmtSupplierControllerCompany$Params } from '../fn/supplier/create-one-base-mgmt-supplier-controller-company';
import { createOneBaseMgmtSupplierOrderControllerSupplierOrder } from '../fn/supplier/create-one-base-mgmt-supplier-order-controller-supplier-order';
import { CreateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params } from '../fn/supplier/create-one-base-mgmt-supplier-order-controller-supplier-order';
import { deleteOneBaseMgmtSupplierControllerCompany } from '../fn/supplier/delete-one-base-mgmt-supplier-controller-company';
import { DeleteOneBaseMgmtSupplierControllerCompany$Params } from '../fn/supplier/delete-one-base-mgmt-supplier-controller-company';
import { deleteOneBaseMgmtSupplierOrderControllerSupplierOrder } from '../fn/supplier/delete-one-base-mgmt-supplier-order-controller-supplier-order';
import { DeleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Params } from '../fn/supplier/delete-one-base-mgmt-supplier-order-controller-supplier-order';
import { getManyBaseMgmtSupplierControllerCompany } from '../fn/supplier/get-many-base-mgmt-supplier-controller-company';
import { GetManyBaseMgmtSupplierControllerCompany$Params } from '../fn/supplier/get-many-base-mgmt-supplier-controller-company';
import { getManyBaseMgmtSupplierOrderControllerSupplierOrder } from '../fn/supplier/get-many-base-mgmt-supplier-order-controller-supplier-order';
import { GetManyBaseMgmtSupplierOrderControllerSupplierOrder$Params } from '../fn/supplier/get-many-base-mgmt-supplier-order-controller-supplier-order';
import { GetManyCompanyResponseDto } from '../models/get-many-company-response-dto';
import { GetManySupplierOrderResponseDto } from '../models/get-many-supplier-order-response-dto';
import { getOneBaseMgmtSupplierControllerCompany } from '../fn/supplier/get-one-base-mgmt-supplier-controller-company';
import { GetOneBaseMgmtSupplierControllerCompany$Params } from '../fn/supplier/get-one-base-mgmt-supplier-controller-company';
import { getOneBaseMgmtSupplierOrderControllerSupplierOrder } from '../fn/supplier/get-one-base-mgmt-supplier-order-controller-supplier-order';
import { GetOneBaseMgmtSupplierOrderControllerSupplierOrder$Params } from '../fn/supplier/get-one-base-mgmt-supplier-order-controller-supplier-order';
import { SupplierOrder } from '../models/supplier-order';
import { updateOneBaseMgmtSupplierControllerCompany } from '../fn/supplier/update-one-base-mgmt-supplier-controller-company';
import { UpdateOneBaseMgmtSupplierControllerCompany$Params } from '../fn/supplier/update-one-base-mgmt-supplier-controller-company';
import { updateOneBaseMgmtSupplierOrderControllerSupplierOrder } from '../fn/supplier/update-one-base-mgmt-supplier-order-controller-supplier-order';
import { UpdateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params } from '../fn/supplier/update-one-base-mgmt-supplier-order-controller-supplier-order';

@Injectable({ providedIn: 'root' })
export class SupplierApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOneBaseMgmtSupplierControllerCompany()` */
  static readonly GetOneBaseMgmtSupplierControllerCompanyPath = '/api/mgmt/suppliers/{id}';

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtSupplierControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtSupplierControllerCompany$Response(params: GetOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = getOneBaseMgmtSupplierControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtSupplierControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtSupplierControllerCompany(params: GetOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.getOneBaseMgmtSupplierControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtSupplierControllerCompany()` */
  static readonly DeleteOneBaseMgmtSupplierControllerCompanyPath = '/api/mgmt/suppliers/{id}';

  /**
   * Delete a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtSupplierControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtSupplierControllerCompany$Response(params: DeleteOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtSupplierControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtSupplierControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtSupplierControllerCompany(params: DeleteOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtSupplierControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtSupplierControllerCompany()` */
  static readonly UpdateOneBaseMgmtSupplierControllerCompanyPath = '/api/mgmt/suppliers/{id}';

  /**
   * Update a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtSupplierControllerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtSupplierControllerCompany$Response(params: UpdateOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = updateOneBaseMgmtSupplierControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtSupplierControllerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtSupplierControllerCompany(params: UpdateOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.updateOneBaseMgmtSupplierControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtSupplierControllerCompany()` */
  static readonly GetManyBaseMgmtSupplierControllerCompanyPath = '/api/mgmt/suppliers';

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtSupplierControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtSupplierControllerCompany$Response(params?: GetManyBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyCompanyResponseDto>> {
    const obs = getManyBaseMgmtSupplierControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtSupplierControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtSupplierControllerCompany(params?: GetManyBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<GetManyCompanyResponseDto> {
    const resp = this.getManyBaseMgmtSupplierControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyCompanyResponseDto>): GetManyCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtSupplierControllerCompany()` */
  static readonly CreateOneBaseMgmtSupplierControllerCompanyPath = '/api/mgmt/suppliers';

  /**
   * Create a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtSupplierControllerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtSupplierControllerCompany$Response(params: CreateOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = createOneBaseMgmtSupplierControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtSupplierControllerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtSupplierControllerCompany(params: CreateOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.createOneBaseMgmtSupplierControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtSupplierOrderControllerSupplierOrder()` */
  static readonly GetOneBaseMgmtSupplierOrderControllerSupplierOrderPath = '/api/mgmt/supplier/{supplierId}/orders/{id}';

  /**
   * Retrieve a single SupplierOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtSupplierOrderControllerSupplierOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params: GetOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    const obs = getOneBaseMgmtSupplierOrderControllerSupplierOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single SupplierOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtSupplierOrderControllerSupplierOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtSupplierOrderControllerSupplierOrder(params: GetOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<SupplierOrder> {
    const resp = this.getOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtSupplierOrderControllerSupplierOrder()` */
  static readonly DeleteOneBaseMgmtSupplierOrderControllerSupplierOrderPath = '/api/mgmt/supplier/{supplierId}/orders/{id}';

  /**
   * Delete a single SupplierOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtSupplierOrderControllerSupplierOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params: DeleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtSupplierOrderControllerSupplierOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single SupplierOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtSupplierOrderControllerSupplierOrder(params: DeleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtSupplierOrderControllerSupplierOrder()` */
  static readonly UpdateOneBaseMgmtSupplierOrderControllerSupplierOrderPath = '/api/mgmt/supplier/{supplierId}/orders/{id}';

  /**
   * Update a single SupplierOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtSupplierOrderControllerSupplierOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params: UpdateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    const obs = updateOneBaseMgmtSupplierOrderControllerSupplierOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single SupplierOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtSupplierOrderControllerSupplierOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtSupplierOrderControllerSupplierOrder(params: UpdateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<SupplierOrder> {
    const resp = this.updateOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtSupplierOrderControllerSupplierOrder()` */
  static readonly GetManyBaseMgmtSupplierOrderControllerSupplierOrderPath = '/api/mgmt/supplier/{supplierId}/orders';

  /**
   * Retrieve multiple SupplierOrders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtSupplierOrderControllerSupplierOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtSupplierOrderControllerSupplierOrder$Response(params: GetManyBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManySupplierOrderResponseDto>> {
    const obs = getManyBaseMgmtSupplierOrderControllerSupplierOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple SupplierOrders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtSupplierOrderControllerSupplierOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtSupplierOrderControllerSupplierOrder(params: GetManyBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<GetManySupplierOrderResponseDto> {
    const resp = this.getManyBaseMgmtSupplierOrderControllerSupplierOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManySupplierOrderResponseDto>): GetManySupplierOrderResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtSupplierOrderControllerSupplierOrder()` */
  static readonly CreateOneBaseMgmtSupplierOrderControllerSupplierOrderPath = '/api/mgmt/supplier/{supplierId}/orders';

  /**
   * Create a single SupplierOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtSupplierOrderControllerSupplierOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params: CreateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    const obs = createOneBaseMgmtSupplierOrderControllerSupplierOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single SupplierOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtSupplierOrderControllerSupplierOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtSupplierOrderControllerSupplierOrder(params: CreateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<SupplierOrder> {
    const resp = this.createOneBaseMgmtSupplierOrderControllerSupplierOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

}
